// extracted by mini-css-extract-plugin
export default {"wrapper":"Common_wrapper__LjhlL","line":"Common_line__XxZ5s","title":"Common_title__XQts8","name":"Common_name__-yBqG","loader":"Common_loader__t4914"};